import { render, staticRenderFns } from "./AcademyBranchListTable.vue?vue&type=template&id=18d45207&scoped=true&lang=pug&"
import script from "./AcademyBranchListTable.vue?vue&type=script&lang=ts&"
export * from "./AcademyBranchListTable.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyBranchListTable.vue?vue&type=style&index=0&id=18d45207&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d45207",
  null
  
)

export default component.exports